<script>
	let { provider } = $props();
</script>

<p>{@html provider.define_access_keys_desc}</p>

<pre>{provider.define_access_keys_example}</pre>
